import script from "./recordVideoMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./recordVideoMenu.vue?vue&type=script&setup=true&lang=js"

import "./recordVideoMenu.vue?vue&type=style&index=0&id=304eccb4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304eccb4"]])

export default __exports__